export default __webpack_public_path__ + "static/media/hristina_s.2e52d4d0.jpg";